/**
 * A SCREEN'S ESSENTIALS (2026-10-20, measured on a site's hub). The gate's own rule, "until the
 * screen's first fetches are in", counts every query the screen starts, and a screen with slow or
 * deferred cards held the full ring long after its frame was ready: a site's hub, from the Sites
 * list, kept it about 15 s while its own detail answered in 18–94 ms and the cards' period reads came
 * twenty seconds later. A screen that knows which data its first paint needs says so here; the gate
 * then shows it as soon as those are in, and the slower cards arrive behind their own placeholders.
 * A screen that says nothing keeps the gate's rule.
 */
import { createContext, useContext, useEffect } from 'react';

/** The gate's ear: a screen's essentials are in (true) or not yet (false). Null outside a gate. */
export const ScreenReadyContext = createContext<((ready: boolean) => void) | null>(null);

/** Tell the screen's gate whether the data its first paint needs is in. */
export function useScreenReady(ready: boolean): void {
  const declare = useContext(ScreenReadyContext);
  useEffect(() => {
    declare?.(ready);
  }, [declare, ready]);
}
